// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileDropdown-cls1_L6O","cls2":"ProfileDropdown-cls2_jx3 ProfileDropdown-cls1_L6O"};